'use client';

import { useGoogleLogin } from '@react-oauth/google';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/common/Button';
import { FcGoogle } from 'react-icons/fc';

interface GoogleLoginButtonProps {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  className?: string;
  buttonText?: string;
}

export function GoogleLoginButton({
  onSuccess,
  onError,
  className,
  buttonText,
}: GoogleLoginButtonProps) {
  const { loginWithGoogle } = useAuth();

  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      try {
        await loginWithGoogle(codeResponse.code);
        onSuccess?.();
      } catch (error) {
        onError?.(
          error instanceof Error ? error.message : 'Failed to login with Google'
        );
      }
    },
    onError: (error) => {
      console.error('Google Login Error:', error);
      onError?.('Failed to login with Google');
    },
  });

  return (
    <Button
      variant="light"
      onClick={() => googleLogin()}
      className={className}
      leftIcon={<FcGoogle className="h-5 w-5" />}
    >
      {buttonText || `Continue with Google`}
    </Button>
  );
}
